import { useDispatch, useSelector } from 'react-redux';
import FJEditPanel from './view/FJEditPanel.jsx';
import FJActionTextBasedEditing from '../../../../redux/action/textBasedEditing/FJActionTextBasedEditing.js';

const FJEditPanelContainer = () => {
    const dispatch = useDispatch();
    const activePanelName = useSelector(state => state.textBasedEditing.activePanelName);
    if (activePanelName !== 'edit') return;

    const _goBack = () => {
        dispatch(FJActionTextBasedEditing.goBackAction());
    };

    return <FJEditPanel goBack={_goBack} />;
};

export default FJEditPanelContainer;
